import { CustomerVehicleIconColor, CustomerVehicleIconType } from "JS/types/Automotive";

export enum VehicleLookupStepType {
	Vehicle = 'Vehicle',
	Trim = 'Trim Size',
	TireSize = 'Tire Size',
	Details = 'Details',
}

export interface VehicleStep {
	type: VehicleLookupStepType.Vehicle;
	complete: boolean;
	dependsOnPreviousStep: false;
	data: {
		availableYears: string[],
		availableMakes: string[],
		availableModels: string[],
		make: string | null,
		model: string | null,
		year: string | null;
	}
}

export interface TrimStep {
	type: VehicleLookupStepType.Trim;
	complete: boolean;
	dependsOnPreviousStep: true;
	data: {
		availableTrims: string[];
		trim: string | false | null;
	}
}

export interface TireSizeStep {
	type: VehicleLookupStepType.TireSize;
	complete: boolean;
	dependsOnPreviousStep: true;
	required: boolean;
	data: {
		availableSizes: string[];
		size: string | null;
	}
}

export interface DetailsStep {
	type: VehicleLookupStepType.Details;
	complete: boolean;
	dependsOnPreviousStep: false;
	data: {
		icon: CustomerVehicleIconType;
		color: CustomerVehicleIconColor | '';
		nickname: string;
		availableColors: CustomerVehicleIconColor[];
		availableIcons: CustomerVehicleIconType[];
	}
}

export type VehicleLookupStep = VehicleStep | TrimStep | TireSizeStep | DetailsStep;